const getters = {
  getCommissions: (state) => state.commissions,
  getCommission: (state) => state.commission,
  getCommissionAll: (state) => state.commissionAll,
  getCommissionMeta: (state) => state.commissionMeta,
  getCommissionUserIds: (state) => state.commissionUserIds,
  getCommissionValues: (state) => state.commissionValues,
  getSelf: (state) => state.self,
  getCommissionDetail: (state) => state.commissionDetail,
  getCommissionDetailMeta: (state) => state.commissionDetailMeta,
  getCommissionDetailQuickView: (state) => state.commissionDetailQuickView,
};

export default getters;
